import { useCookie, readonly } from '#imports';
let sessionCookiesInstance = null

/**
 * useCookie Must be called within composable setup.
 * To update cookies, this useSessionCookies composable returns callback methods to update cookie.value
 */
export const useSessionCookies = () => {
  const initSessionCookies = () => {
    if (! sessionCookiesInstance) {
      const wooSessionCookie = useCookie('woo-session', {
        default: () => '',
      })
      
      const userSelectedCurrencyCookie = useCookie('aelia_cs_selected_currency', {
        default: () => 'USD',
      })
      
      const userSelectedCountryCookie = useCookie('aelia_customer_country', {
        default: () => 'US',
      })
      
      sessionCookiesInstance = {
        // Getters for cookie values
        wooSession: readonly(wooSessionCookie),
        userSelectedCurrency: readonly(userSelectedCurrencyCookie),
        userSelectedCountry: readonly(userSelectedCountryCookie),
        
        // Update methods
        update_woo_session: (newValue) => {
          wooSessionCookie.value = newValue
        },
        
        update_user_selected_currency: (newValue) => {
          userSelectedCurrencyCookie.value = newValue
        },
        
        update_user_selected_country: (newValue) => {
          userSelectedCountryCookie.value = newValue
        },
        
        clear_all_session: () => {
          wooSessionCookie.value = ''
          userSelectedCurrencyCookie.value = 'USD'
          userSelectedCountryCookie.value = 'US'
        },
      }
    }
  }
  
  return {
    ...sessionCookiesInstance,
    initSessionCookies
  }
}
